import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const volumeNames = ['Salsa Foundations, Timing, Footwork & Shines', 'Bachata Foundations, Body Movement, Footwork & Styling', 'Partnerwork, Connection, Leading, Following & Turns', 'Musicality, Combinations & Social Dance Development', 'Instructor Method, Corrections, Class Structure & Student Progression', '150 Ready-to-Teach Salsa & Bachata Classes'];
const separateAreas = ['Salsa technique.', 'Bachata technique.', 'Partnerwork.', 'Musicality.', 'Teaching methodology.', 'Complete class plans.'];
export function SystemOverview() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-290" data-mp="13u39gn198x75">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-16" data-id="element-291" data-mp="yw1mvs4mefqx">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-292" data-mp="2fajpoikmvhv2">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-293" data-mp="235kx9qaznc4x">
            Your 6-in-1 system
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-294" data-mp="287a93861btu2">
            Why buy six different resources when you can have one complete{' '}
            <span className="italic text-burgundy" data-id="element-295" data-mp="2i34wshp48f3p">6-in-1</span> system?
          </h2>
          <Ornament align="left" className="mt-5" data-id="element-296" data-mp="1kh7h0s24envg" />
          <ol className="mt-8 divide-y divide-gold/25 border-y border-gold/25" data-id="element-297" data-mp="1pezb9sq8mm2t">
            {volumeNames.map((name, index) => <li key={name} className="flex items-baseline gap-4 py-3.5" data-id="element-298" data-mp="1udsr3rszyp65" data-mpi={index}>
                <span className="w-6 shrink-0 font-display text-2xl font-semibold text-burgundy" data-id="element-299" data-mp="1z4iuizhv4hy7">
                  {index + 1}
                </span>
                <span className="text-base font-medium text-ink" data-id="element-300" data-mp="11ovg89r47unf">{name}</span>
              </li>)}
          </ol>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.08em] text-burgundy" data-id="element-301" data-mp="16m52xhn4ds7k">
            6 Volumes. 150 Classes. 2 Dance Styles. 1 Complete System.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="self-start rounded-2xl border border-gold/30 bg-white p-6 shadow-soft sm:p-9" data-id="element-302" data-mp="tmuum70tq73l">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-303" data-mp="aqcyzeiutn22">
            Instead of searching separately for:
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-304" data-mp="pl0x27lxdj7n">
            {separateAreas.map(item => <li key={item} className="rounded-full border border-gold/30 bg-cream px-3 py-1.5 text-xs font-medium text-ink" data-id="element-305" data-mp="kq3qr8g15nyg">
                {item}
              </li>)}
          </ul>
          <p className="mt-8 border-t border-gold/25 pt-6 font-display text-xl font-medium leading-8 text-ink" data-id="element-306" data-mp="23m5py6xro10x">
            You get all six areas organized inside{' '}
            <span className="italic text-burgundy" data-id="element-307" data-mp="28jfelkdc08np">one complete instructor system.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}